<template>
  <div class="template-steps-with-icons">
    <div class="content pb-5 pt-3">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <MaterialHeader :content="content"/>
            <div v-if="content.acf.icon_before_title.text"
                 class="icon-before-title d-flex justify-content-start align-items-center mb-4 pt-3">
              <img v-if="content.acf.icon_before_title.icon" :src="content.acf.icon_before_title.icon"/>
              <p :style="{
                color: content.acf.icon_before_title.text_color ? content.acf.icon_before_title.text_color : 'inherit'
                }" class="m-0 ml-4">{{content.acf.icon_before_title.text}}</p>
            </div>
            <h2 class="text-primary bold mb-4 material-title"
                v-html="content.title.rendered"></h2>
            <p class="material-subtitle text-secondary mb-5">{{content.acf.subtitle}}</p>
          </div>
        </div>
        <div class="content-body">
          <div v-if="content.acf.text_before_accordion"
               class="text-before-accordion mb-5"
               v-html="content.acf.text_before_accordion"></div>
          <template v-if="content.acf.flexible_content_before">
            <div v-for="(component, i) in content.acf.flexible_content_before" :key="i">
              <!-- Simple text -->
              <div v-if="component.acf_fc_layout === 'simple_text'"
                   v-html="component.simple_text_content"
                   class="mb-5"></div>
              <!-- Gallery -->
              <div v-if="component.acf_fc_layout === 'gallery'" class="mb-5">
                <Gallery v-if="component.gallery.length" :images="component.gallery"/>
              </div>
              <!-- Video -->
              <div v-if="component.acf_fc_layout === 'video'" class="mb-5 video-wrapper">
                <b-aspect aspect="16:9">
                  <div class="video-holder" v-html="component.video"></div>
                </b-aspect>
              </div>
            </div>
          </template>
          <div class="accordion">
            <template v-for="(item, i) in content.acf.accordion">
              <div v-if="item.header" class="accordion-item" :key="`acc-${i}`">
                <div class="row">
                  <div class="col-12">
                    <h3 class="pointer d-flex justify-content-between align-items-center"
                        v-b-toggle="`collapse-acc-${i}`">
                      <span class="accordion-title">
                        <span class="mr-4 header-icon" v-if="item.header_icon">
                          <img :src="item.header_icon">
                        </span>
                        <span class="bold">{{item.header}}</span>
                      </span>
                      <span :class="{'d-none': documentGenerating}">
                        <img src="@/assets/icons/plus-secondary-thin.svg" class="img-fluid when-closed">
                        <img src="@/assets/icons/arrow-primary.svg" class="img-fluid when-open">
                      </span>
                    </h3>
                    <b-collapse :id="`collapse-acc-${i}`" :visible="documentGenerating">
                      <div class="accordion-content mt-2">
                        <div class="d-flex">
                          <div class="addition-icon-on-the-left">
                            <img :src="item.additional_icon_on_the_left" v-if="item.additional_icon_on_the_left">
                          </div>
                          <div class="accordion-content--body w-100">
                            <section v-for="(content, i) in item.content" :key="i">
                              <div v-if="content.acf_fc_layout === 'simple_text'">
                                <div v-html="content.simple_text_content" class="simple-text text-sm"></div>
                              </div>
                              <div v-if="content.acf_fc_layout === 'gallery'">
                                <Gallery v-if="content.images.length" :images="content.images"/>
                              </div>
                              <div v-if="content.acf_fc_layout === 'table_extended'">
                                <TableExtended :tableContents='content.table_content'/>
                              </div>
                              <!-- Video -->
                              <div v-if="content.acf_fc_layout === 'video'" class="video-wrapper">
                                <b-aspect aspect="16:9">
                                  <div class="video-holder" v-html="content.video"></div>
                                </b-aspect>
                              </div>
                            </section>
                          </div>
                        </div>
                      </div>
                    </b-collapse>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MaterialHeader from '@/templates/template-parts/MaterialHeader.vue';
import Gallery from '@/templates/template-parts/Gallery.vue';
import TableExtended from '@/templates/template-parts/TableExtended.vue';

export default {
  props: {
    content: Object,
    documentGenerating: null,
  },
  data() {
    return {
      lightboxItems: [],
      lightboxIndex: null,
    };
  },
  components: {
    MaterialHeader,
    Gallery,
    TableExtended,
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
.icon-before-title {
  img {
    max-width: 40px;
  }
  p {
    font-size: 20px;
  }
}
.material-subtitle {
  font-size: 25px;
}
@include media-breakpoint-down(lg) {
  .material-title {
    font-size: 24px;
  }
  .material-subtitle {
    font-size: 20px;
  }
}
.accordion {
  .accordion-item {
    &:first-of-type {
      border-top: 1px solid $secondary;
    }
    border-bottom: 1px solid $secondary;
    h3 {
      font-size: 20px;
      margin: 0;
      padding: .9em 0 .9rem .5rem;
      .accordion-title {
        display: flex;
        align-items: center;
        .header-icon {
          img {
            max-width: 30px;
            width: 100%;
            margin: 0;
            filter: $filter-to-secondary;
          }
        }
        @include media-breakpoint-down(sm) {
          .header-icon img {
            max-width: 20px;
          }
        }
      }
      img {
        width: 15px;
        margin: 0 10px 0 10px;
      }
      &:focus {
        outline: 0;
      }
      img.when-open {
        transform: rotate(-90deg);
      }
      &.collapsed img.when-open,
      &.not-collapsed img.when-closed {
        display: none;
      }
    }
    .accordion-content {
      padding: 0 35px 20px 0;
      @include media-breakpoint-down(sm) {
        padding: 0 0 10px 0;
        .addition-icon-on-the-left {
          min-width: 50px!important;
          height: 100%;
          img {
            max-width: 20px!important;
          }
        }
      }
      ::v-deep img {
        max-width: 100%;
        height: auto;
      }
      .addition-icon-on-the-left {
        min-width: 65px;
        height: 100%;
        padding-left: .8rem;
        margin-top: 15px;
        img {
          max-width: 30px;
        }
      }
      &--body {
        @include media-breakpoint-down(sm) {
          overflow: hidden;
        }
        section:not(:last-child) {
          > div {
            margin-bottom: 2rem;
            @include media-breakpoint-down(lg) {
              margin-bottom: 1rem;
            }
          }
        }
      }
      .simple-text ::v-deep > p:last-child {
        margin-bottom: 0;
      }
    }
  }
}
::v-deep ul {
  @extend .list-square;
}
.video-holder {
  height: 100%;
  ::v-deep iframe {
    width: 100%;
    height: 100%;
  }
}
</style>
